import { CLASSIC_QR_BOUNDS, JOURNEY_QR_BOUNDS, POSTER_H, POSTER_W } from './poster-design';

export const JOURNEY_QR_IMAGE = '/clinical-trials/posters/templates/Rudi_templates.png';

function PointingHand() {
  return (
    <g stroke="#40352e" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
      <path
        fill="#e8d9c9"
        d="M-10 76 75 88Q99 91 120 78L165 48 235 13Q248 6 264 10L280 13Q291 17 290 25 290 31 278 32L252 34 290 31Q307 29 319 37 330 43 327 52 325 59 312 64L286 74 323 66Q343 59 355 68 366 76 360 86 355 94 339 100L304 112 422 99Q443 94 449 103 454 114 435 120L389 137 333 156Q316 163 307 177L323 176Q337 177 345 186 354 196 342 201L306 204 277 216Q250 222 226 216L171 204Q141 196 120 184L-10 178Z"
      />
      <path
        fill="#dcb7a5"
        opacity="0.45"
        stroke="none"
        d="M118 81Q148 61 185 51L248 19 277 21 237 39 202 63 166 101Q145 132 156 160 170 188 206 207L170 200 125 179Q135 155 127 127Z"
      />
      <path
        fill="#f3e7d5"
        opacity="0.55"
        stroke="none"
        d="M-10 87 94 96Q122 123 111 166L-10 167ZM188 98Q199 71 230 72L294 48 308 48 270 85 304 81 334 73 341 81 288 118 409 108 420 111 322 147Q282 165 267 193 230 208 196 188 165 164 188 98Z"
      />
      <path
        fill="none"
        d="M122 94Q138 100 145 115M251 34l-17 3m54 36-27 9m44 31-31 10m32 54-25 10m39 2q16-4 22 4M430 102q-8 8 0 14M267 15q14 0 18 7"
      />
      <path
        fill="none"
        opacity="0.3"
        d="M169 180q21 14 47 15m-43-88q-10 15-10 31m70-43 19-7m49 55 25-11"
      />
    </g>
  );
}

export function PosterJourneyArtwork({ qrImage }: { qrImage: string }) {
  const qr = CLASSIC_QR_BOUNDS;
  return (
    <>
      <g transform="translate(-18 850) scale(1.24)">
        <PointingHand />
      </g>
      <g transform="translate(1605 850) scale(-1.24 1.24)">
        <PointingHand />
      </g>
      <rect
        x={JOURNEY_QR_BOUNDS.x - 22}
        y={JOURNEY_QR_BOUNDS.y - 22}
        width={JOURNEY_QR_BOUNDS.width + 44}
        height={JOURNEY_QR_BOUNDS.height + 44}
        fill="#ffebdf"
      />
      <svg {...JOURNEY_QR_BOUNDS} viewBox={`${qr.x} ${qr.y} ${qr.width} ${qr.height}`}>
        <image href={qrImage} width={POSTER_W} height={POSTER_H} />
      </svg>
    </>
  );
}
